import ContactCard from './ContactCard';

export * from './ContactCardProps';
export * from './ContactCardRef';
export default ContactCard;
